const API_PREFIX = '/prod-api'

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || ''
  let payload = {}

  if (contentType.includes('application/json')) {
    payload = await response.json()
  } else {
    const text = await response.text()
    payload = text ? { msg: text } : {}
  }

  if (!response.ok) {
    throw new Error(payload.msg || `请求失败：${response.status}`)
  }

  const code = payload.code === undefined ? 200 : payload.code
  if (code !== 200) {
    throw new Error(payload.msg || '请求处理失败')
  }

  return payload
}

function createHeaders(token, extras = {}) {
  const headers = {
    Accept: 'application/json',
    ...extras
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  return headers
}

export async function getCodeImg() {
  const response = await fetch(`${API_PREFIX}/captchaImage`, {
    headers: createHeaders('', {
      'Cache-Control': 'no-cache'
    })
  })

  return parseResponse(response)
}

export async function login(payload) {
  const response = await fetch(`${API_PREFIX}/login`, {
    method: 'POST',
    headers: createHeaders('', {
      'Content-Type': 'application/json'
    }),
    body: JSON.stringify(payload)
  })

  return parseResponse(response)
}

export async function getInfo(token) {
  const response = await fetch(`${API_PREFIX}/getInfo`, {
    headers: createHeaders(token)
  })

  return parseResponse(response)
}
